import React from 'react';
import styled from 'styled-components';
import { media } from 'styles/breakpoints';
import common from 'styles/common';

const Container = styled.a`
  border: 1px solid #e5e5e5;
  box-shadow: ${common.boxShadow};
  color: #333;
  display: block;
  margin: 10px;
  text-decoration: none;
  width: 400px;

  ${media.small`
    margin: 25px;
    min-width: 400px;
    min-height: 244px;
  `};
`;

const TextWrap = styled.div`
  padding: 10px 20px;

  ${media.medium`
    padding: 20px;
  `};
`;

const ImageWrap = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  max-height: 150px;
  overflow: hidden;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
`;

const Description = styled.p`
  font-family: 'Lato', sans-serif;
  font-weight: 300;
  margin: 0;
  font-size: 14px;
  line-height: 20px;
`;

const Title = styled(Description)`
  font-size: 18px;
  line-height: 22px;
  font-weight: 500;
  margin-bottom: 10px;
`;

export default function ImageCard({
  description,
  imageUrl,
  onClick,
  title,
  url
}) {
  return (
    <Container
      onClick={onClick}
      href={url}
      rel="noopener noreferrer"
      target="_blank"
    >
      <ImageWrap>
        <Image src={imageUrl} />
      </ImageWrap>
      <TextWrap>
        <Title>{title}</Title>
        <Description>{description}</Description>
      </TextWrap>
    </Container>
  );
}



// WEBPACK FOOTER //
// ./src/components/ImageCard/ImageCard.js